import { render, staticRenderFns } from "./DeliveryProducts.vue?vue&type=template&id=534b59b0&scoped=true&"
import script from "./DeliveryProducts.vue?vue&type=script&lang=js&"
export * from "./DeliveryProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b59b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534b59b0')) {
      api.createRecord('534b59b0', component.options)
    } else {
      api.reload('534b59b0', component.options)
    }
    module.hot.accept("./DeliveryProducts.vue?vue&type=template&id=534b59b0&scoped=true&", function () {
      api.rerender('534b59b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/DeliveryProducts.vue"
export default component.exports